<template>
    <div class="" role="alert" :class="[alertClass]">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "Alert",

    props: {
        variant: {
            type: String,
            required: true,
            default: "info",
        },
        show: {
            type: Boolean,
            // required: true,
        },
    },

    data() {
        return {
            show: false,
        };
    },

    methods: {
        // close() {
        //   this.show = false;
        // },
    },

    computed: {
        alertClass() {
            return {
                "mb-5 text-small-text-regular text-salmon flex w-full":
                    this.variant === "error",
                "rounded-xl px-5 py-4 mb-4 text-sm w-full font-medium alert--success":
                    this.variant === "success",
                "rounded-xl px-5 py-4 mb-4 text-sm w-full font-medium alert--warning":
                    this.variant === "warning",
            };
        },
    },
};
</script>
